import {Navigator} from "../Navigator";
import {ViewConfig} from "./ViewConfig";

/**
 * Application configuration
 */
export class App3DConfig {
	/** Base URL for loading resources. */
	public app_root: string = null;
	/** View configuration. */
	public view_config: ViewConfig = null;
	/** JQuery selector for GUI container */
	public gui_container: string = '.App3D-gui';
	/** Basic URL for all resources (```~```). */
	protected resource_root: string = null;
	/** Basic URL for textures. */
	public texture_path: string = '~/textures/';
	/** Basic URL for shaders. */
	public shader_path: string = '~/shaders/';
	/** Basic URL for models. */
	public model_path: string = '~/models/';

	/** Model scale */
	public model_scale: number = 3.0;
	/** Floor offset */
	public floor: number = -1.0;
	/** Duration of property-change effect. */
	public effect_duration: number = 0;

	// https://github.com/mrdoob/three.js/issues/11887
	/** Whether to enable application-defined materials. */
	public enable_materials: boolean = true;

	/** Whether to disable THREE loader cache */
	public disable_cache: boolean = false;

	/**
	 * Whether to pre-load other product models when loading of active product is finished.
	 * (calls preloadProductAssets() after initialization)
	 */
	public preload_models: boolean = false;

	/**
	 * JQuery selector for progress bar (this will be used to show loading progress).
	 * @see https://getbootstrap.com/docs/4.0/components/progress/
	 */
	public progress_bar: string = null;
	/** Navigator object (will be created automatically if not defined. */
	public navigator: Navigator | object = null;
	/** JQuery selector for navigator element (to attach navigator events) - main App3D container is used if not defined. */
	public navigator_area: JQuery = null;

	public background: string = null;

	/**
	 * @hidden
	 * @internal
	 * Internal jQuery instance (to avoid jQuery version collisions)
	 */
	public jQuery: JQueryStatic = null;

	/**
	 * @hidden
	 * Recognize home directory in path config vars
	 */
	public static reHome = /^~\//;

	/**
	 * Translates relative to absolute path
	 * @param pathOrg
	 */
	public translatePath(pathOrg: string){
		return pathOrg.replace(App3DConfig.reHome, this.resource_root);
	}
}

/**
 * Internal App3DConfig class
 */
export class App3DConfigInt extends App3DConfig{
	constructor(data: object, view: JQuery){
		super();
		Object.assign(this, data);
		if (!this.app_root)
			throw new Error(`Required option 'app_root' is empty!`);

		if (!this.resource_root)
			this.resource_root = this.app_root + 'data/';

		this.model_scale = Number(this.model_scale);
		this.floor = Number(this.floor);

		if (!this.view_config)
			this.view_config = new ViewConfig();

		if (!this.navigator_area)
			this.navigator_area = view;
		this.texture_path = this.translatePath(this.texture_path);
		this.shader_path = this.app_root; // shader path included
		// this.shader_path = this.shader_path.replace(reHome, this.resource_root);
		this.model_path = this.translatePath(this.model_path);
	}
}




// WEBPACK FOOTER //
// ./src/script/app3D/config/App3DConfig.ts